var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmptyPrizes(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 262,
    height: 260,
    viewBox: "0 0 262 260",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_885_2751)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36.4102 124.477L68.0772 92.9992L131.825 29.6521L198.141 96.0602L225.564 123.522L130.149 218.326L36.4102 124.477Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.227 25.1205L142.227 25.1206L230.177 113.173L240.574 123.586L230.135 133.957L230.487 134.311L230.135 133.957L140.618 222.921L130.177 233.293L119.778 222.879L31.828 134.805L31.8277 134.804L21.431 124.413L31.8702 114.042L31.8703 114.042L121.387 25.0785L121.387 25.0785L131.828 14.7057L142.227 25.1205ZM132.096 39.9359L131.744 39.5831L131.39 39.9345L46.7269 124.057L46.3713 124.411L46.7255 124.765L129.909 208.063L130.261 208.416L130.615 208.064L215.278 123.92L215.634 123.567L215.28 123.212L132.096 39.9359Z",
    fill: "#0321F8",
    stroke: "#0FF0DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.741 155.575H90.3831C87.1293 155.575 84.5156 152.945 84.5156 149.671V100.715C84.5156 97.79 86.6492 95.2671 89.5563 94.8645C117.56 90.9728 145.564 90.9728 173.567 94.8645C176.448 95.2671 178.608 97.79 178.608 100.715V149.671C178.608 152.918 175.994 155.575 172.741 155.575Z",
    fill: "#0218FB",
    stroke: "white",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.608 118.988H84.5156",
    stroke: "white",
    strokeWidth: 3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.059 118.988V155.575",
    stroke: "white",
    strokeWidth: 3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.66 118.988V155.575",
    stroke: "white",
    strokeWidth: 3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.333 111.035H120.787C119.25 111.035 118.004 112.28 118.004 113.817V125.75C118.004 127.287 119.25 128.533 120.787 128.533H142.333C143.869 128.533 145.115 127.287 145.115 125.75V113.817C145.115 112.28 143.869 111.035 142.333 111.035Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_885_2751",
    x: 0.71875,
    y: -0.000488281,
    width: 260.562,
    height: 260,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 6
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.18767 0 0 0 0 0.926514 0 0 0 0 0.837852 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_885_2751"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_885_2751",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyPrizes);
export default __webpack_public_path__ + "static/media/empty-prizes.98fa49a8dc869b0f224ea94c52926d13.svg";
export { ForwardRef as ReactComponent };